import { render, staticRenderFns } from "./ProductDetailList.vue?vue&type=template&id=225f43e2&scoped=true"
import script from "./ProductDetailList.vue?vue&type=script&lang=js"
export * from "./ProductDetailList.vue?vue&type=script&lang=js"
import style0 from "./ProductDetailList.vue?vue&type=style&index=0&id=225f43e2&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "225f43e2",
  null
  
)

export default component.exports